<!--
 * @Author: zhujun zhujun@yhb-work.com
 * @Date: 2024-09-30 10:41:46
 * @LastEditors: luoyuhao luoyuhao@yhb-work.com
 * @LastEditTime: 2026-04-01 14:51:26
 * @FilePath: \YHB_H5\src\pages\ydb\agreemnet.vue
 * @Description: 聚充充用户协议与隐私政策
-->
<template>
  <div class="content">
    <div v-html="content"></div>
  </div>
</template>
<script>
  // import { getAgreementByType } from '@/api/ydb'
  import { agreements } from '@/utils/agreement'

  const AGREEMENT_KEY_BY_TYPE_ID = {
    91: 'agent3',
    92: 'agent5',
    93: 'angen6',
    94: 'agent4',
    95: 'addAgent2',
    97: 'addAgent1'
  }

  export default {
    data() {
      return {
        title: '',
        content: '',
        agreementList: [
          { id: 91, title: "有电豹用户服务协议"  }, //（代理端）
          { id: 92, title: "有电豹用户隐私协议" }, //（代理端）
          { id: 93, title: "有电豹用户隐私协议" }, //（用户端）
          { id: 94, title: "有电豹用户服务协议" }, //（用户端）
          { id: 95, title: "有电豹平台使用规则" }, //（用户端）
          { id: 97, title: "有电豹充电功率说明" }, //（用户端）
        ]
      }
    },
    mounted() {
      let typeId = this.$route.query.typeId
      if (this.agreementList.find(item => item.id == typeId)) {
        this.getInformation(typeId)
      } else {
        alert('未查到相关文件')
      }
    },
    methods: {
      getInformation(typeId) {
        const agreementKey = AGREEMENT_KEY_BY_TYPE_ID[typeId]
        const agentData = agreements()[agreementKey]
        if (agentData && agentData.content) {
          this.title = agentData.title;
          document.title = agentData.title
          this.content = agentData.content
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .content {
    padding: 30px;
    line-height: 1.8;

    pre {
      white-space: pre-line;
    }
  }
</style>
